import styled from 'styled-components';

export const OneDayVIPButtonStyles = styled.button`
  display: block;
  border-radius: 70px;
  border: none;
  background: linear-gradient(180deg, #a77aff 0%, #6d2ceb 100%);
  padding: 16px 60px;
  color: #fff;
  margin: 24px auto 16px;
  width: 100%;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  text-transform: inherit;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(167, 122, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
